  export class PostDateCheques {
    constructor(
        public uid?: string,
        public version?: string,
        public chequeNo?: string,
        public chequeDate?: Date,
        public chequeAmount?: number,
        public chequePayto?: string,
        public purpose?: string,
        public accountNo?: string,
        public accountType?: string,
        public accountHolderName?: string,
        public bankName?: string,
        public branchName?: string,
        public micr?: string,
        public chequeScanFolder?: string,
        public status?: string,
        public contextType?: string,
        public contextId?: string,
        public contextUid?: string,
        public amount?: number,
        public referenceNumber?: string,
        public deleteBtnDisabled?: boolean,//added for client side use this paramenter will not come from server
    ) { }
  }
